export const isEmpty = (value: any): boolean => {
  // Check for null or undefined
  if (value == null) {
    return true;
  }

  // Check for empty string
  if (typeof value === 'string' || Array.isArray(value)) {
    return value?.length === 0;
  }

  // Check for empty object
  if (typeof value === 'object') {
    return Object.keys(value)?.length === 0;
  }

  // Handle other types (numbers, booleans, etc.)
  return false;
};

export const generateRandomString = () => Math.random().toString(36).substring(2, 15)
  + Math.random().toString(36).substring(2, 15);

type ErrorObject = {
  [key: string]: any;
};

export const handleErrorMessages = (
  error: any[] | ErrorObject,
  callback: (errorString: string
  ) => void,
) => {
  const errorMsg: string[] = [];

  const errorMessage = (err: any) => {
    if (Array.isArray(err)) {
      err.forEach((item) => {
        errorMessage(item);
      });
    } else if (typeof err === 'object' && err !== null) {
      Object.keys(err).forEach((item) => {
        errorMessage(err[item]);
      });
    } else if (typeof err === 'string') {
      errorMsg.push(err);
    }
  };

  errorMessage(error);

  if (errorMsg?.length > 0) {
    callback(errorMsg.join(', '));
  } else {
    callback('Something went wrong, please try again later.');
  }
};

export const createAbortSignal = () => {
  const controller = new AbortController();
  return controller;
};
